module.exports = __webpack_public_path__ + "img/图1-2加长幅面.3b889995.jpg";